import React, { useContext } from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { LanguageContext } from '../context/LanguageContext';
import { Section, SectionHeader } from './ui/Section';
import { Button } from './ui/Button';

const copy = {
  en: {
    machines: 'machines',
    helpTitle: 'Need help choosing?',
    helpDesc: 'Our team will help you find the right plan for your business.',
    helpCta: 'Talk to our team',
  },
  es: {
    machines: 'máquinas',
    helpTitle: '¿Necesitas ayuda para elegir?',
    helpDesc: 'Nuestro equipo te ayuda a encontrar el plan adecuado para tu negocio.',
    helpCta: 'Habla con nuestro equipo',
  },
};

const SubscriptionPlans = () => {
  const { subscriptionTitle, subscriptionDescription, subscriptionPerMachine, subscriptionUpTo, subscriptionChoose, subscriptionRecommended, plans, language } =
    useContext(LanguageContext);
  const t = copy[language] || copy.en;
  const prefix = language === 'es' ? '/es' : '';

  return (
    <Section tone="light" id="subscriptionplans">
      <SectionHeader title={subscriptionTitle} lead={subscriptionDescription} />

      <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {plans.map((plan) => {
          const featured = plan.recommended;
          return (
            <div
              key={plan.name}
              className={`flex flex-col rounded-2xl p-8 ${
                featured ? 'bg-brand-navy text-white' : 'border border-brand-line bg-white text-brand-ink'
              }`}
            >
              <div className="flex items-center justify-between">
                <h3 className={`mb-0 font-display text-lg font-bold ${featured ? 'text-white' : 'text-brand-navy'}`}>{plan.name}</h3>
                {featured && (
                  <span className="rounded-full bg-brand-mint px-3 py-1 text-xs font-semibold text-brand-ink">{subscriptionRecommended}</span>
                )}
              </div>

              <p className={`mb-0 mt-6 font-display text-5xl font-extrabold tracking-tight ${featured ? 'text-white' : 'text-brand-ink'}`}>
                ${typeof plan.price === 'number' ? plan.price.toFixed(2) : plan.price}
              </p>
              <p className={`mb-0 mt-1 text-sm ${featured ? 'text-white/60' : 'text-slate-500'}`}>{subscriptionPerMachine}</p>
              <p className={`mb-0 mt-1 text-sm ${featured ? 'text-white/80' : 'text-slate-600'}`}>
                {subscriptionUpTo} {plan.maxMachines} {t.machines}
              </p>

              <ul className={`my-8 flex-1 space-y-3 border-t pt-8 ${featured ? 'border-white/15' : 'border-brand-line'}`}>
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3 text-sm">
                    <Check className={`mt-0.5 h-4 w-4 flex-shrink-0 ${featured ? 'text-brand-mint' : 'text-brand-teal'}`} />
                    <span className={featured ? 'text-white/85' : 'text-slate-700'}>{feature}</span>
                  </li>
                ))}
              </ul>

              <Button to={`${prefix}/register-owner`} variant={featured ? 'inverse' : 'secondary'} className="w-full">
                {subscriptionChoose}
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          );
        })}
      </div>

      <div className="mt-6 flex flex-col items-start justify-between gap-4 rounded-2xl bg-brand-mist p-8 md:flex-row md:items-center">
        <div>
          <h3 className="mb-1 font-display text-xl font-bold text-brand-navy">{t.helpTitle}</h3>
          <p className="mb-0 text-slate-600">{t.helpDesc}</p>
        </div>
        <Button to={`${prefix}/support`} variant="secondary">
          {t.helpCta}
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </Section>
  );
};

export default SubscriptionPlans;
